import { Matrix4, Vector3 } from 'three'
import type { Engine } from '../../core/engine/Engine.type'
import { getEngineThreeControls } from '../fn/getSetEngineThreeControls'
import { getEngineThreeMainCamera } from '../fn/getSetEngineThreeMainCamera'
import useMainScene from '../fn/useMainScene'
import createOnScreenCompassObject3D from './createOnScreenCompassObject3D'

export default function addOnScreenCompassToMapControlsEvents(
  engine: Engine,
): void {

  const camera = getEngineThreeMainCamera(engine)
  const mapControls = getEngineThreeControls(engine)
  const scene = useMainScene(engine)

  const compass = createOnScreenCompassObject3D()
  scene.add(compass)

  mapControls.addEventListener('change', () => {
    // Define the compass offset relative to the camera (adjust as needed)
    // const compassOffset = new Vector3(-0.8, -0.8, -1) // X and Y for screen positioning, Z for distance in front

    // Convert from screen space to world space
    // const worldPosition = compassOffset.clone().unproject(camera)

    // Compute the forward direction of the camera to position the compass correctly
    const cameraDirection = new Vector3()
    camera.getWorldDirection(cameraDirection)

    // Push the compass forward in front of the camera
    const distanceFromCamera = 10 // Adjust as needed
    const compassPosition = camera.position.clone().add(cameraDirection.multiplyScalar(distanceFromCamera))

    // Offset the compass in local camera space
    const cameraMatrix = new Matrix4().extractRotation(camera.matrixWorld)
    const screenOffset = new Vector3(-5, -3, -6) // Adjust position in local camera space
    screenOffset.applyMatrix4(cameraMatrix)

    // Final position
    compass.position.copy(compassPosition.add(screenOffset))

    // Make the compass always face the camera
    compass.quaternion.copy(camera.quaternion)

    // Ensure "N" always points north
    compass.rotation.z = 0
    // compass.rotation.y = -camera.rotation.y
  })
}
